import { Icon } from "./Icons";

type Size = "sm" | "md" | "lg";

const DIM: Record<Size, number> = { sm: 40, md: 50, lg: 56 };
const ICON_DIM: Record<Size, number> = { sm: 16, md: 19, lg: 22 };

export function ControlButton({
  icon,
  label,
  active = false,
  danger = false,
  primary = false,
  disabled = false,
  size = "md",
  onClick,
  title,
}: {
  icon: string;
  label?: string;
  active?: boolean;
  danger?: boolean;
  primary?: boolean;
  disabled?: boolean;
  size?: Size;
  onClick?: () => void;
  title?: string;
}) {
  const dim = DIM[size];
  const iconSize = ICON_DIM[size];

  let bg = "oklch(0.22 0.008 280 / 0.7)";
  let fg = "var(--text)";
  let bd = "oklch(1 0 0 / 0.08)";

  if (disabled) {
    bg = "oklch(0.2 0.008 280 / 0.4)";
    fg = "var(--text-4)";
    bd = "oklch(1 0 0 / 0.05)";
  } else if (danger) {
    bg = "var(--red)";
    fg = "#fff";
    bd = "var(--red)";
  } else if (primary) {
    bg = "var(--accent)";
    fg = "var(--accent-fg)";
    bd = "var(--accent)";
  } else if (active) {
    bg = "oklch(0.95 0 0 / 0.95)";
    fg = "#111";
    bd = "transparent";
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <button
        onClick={onClick}
        disabled={disabled}
        title={title}
        style={{
          width: dim,
          height: dim,
          borderRadius: "50%",
          background: bg,
          color: fg,
          border: `1px solid ${bd}`,
          display: "grid",
          placeItems: "center",
          cursor: disabled ? "not-allowed" : "pointer",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          boxShadow: disabled
            ? "none"
            : "0 4px 12px oklch(0 0 0 / 0.25)",
          transition: "background 120ms ease",
        }}
      >
        <Icon name={icon} size={iconSize} stroke={2} />
      </button>
      {label && (
        <span
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: 10.5,
            color: "var(--text-2)",
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}
